
export enum EnumIdsTcEstadoSolicitudAtestFito {
    ID_BORRADOR = 1,
    ID_NUEVA = 2,
    ID_CONFORME = 3,
    ID_NO_CONFORME = 4,
    ID_ANULADA = 5
}

export enum EnumIdsTcTipoSolicitudAtestFito {
    ID_COMUNIDAD_AUTONOMA = 1,
    ID_AGENTE_CONTROL = 2,
}

export enum EnumIdsTcResultadoSolicitudAtestFito {
    ID_PENDIENTE = 1,
    ID_ACEPTADA = 2,
    ID_RECHAZADA = 3
}
